import(/* webpackMode: "eager" */ "/app/components/BlogCardSlider.js");
import(/* webpackMode: "eager" */ "/app/components/DistrictCardSlider.js");
import(/* webpackMode: "eager" */ "/app/components/FacebookTimeline.js");
import(/* webpackMode: "eager" */ "/app/components/Hero.js");
import(/* webpackMode: "eager" */ "/app/components/HomeMap.js");
import(/* webpackMode: "eager" */ "/app/components/NewDevelopmentCardSlider.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyCardSlider.js");
import(/* webpackMode: "eager" */ "/app/components/ServiceCards.js");
import(/* webpackMode: "eager" */ "/app/components/TestamonialCard.js")